import { FleekError } from './FleekError';

type GitSecretsFailedToEncryptErrorOptions = Record<string, never>;

export class GitSecretsFailedToEncryptError extends FleekError<GitSecretsFailedToEncryptErrorOptions> {
  public name = 'GitSecretsFailedToEncryptError';

  toString = () => 'Failed to encrypt Git Secrets.';
}
